// ============================================================================
// Supply approvals — the two saves the approvals screen makes, shared with Ask
// AI's supply card (item #944). Both are SECURITY DEFINER functions that check
// the role and, for an account manager, that the building is theirs.
// ============================================================================

import { supabase } from '../../shared/supabase';
import { refreshReaders } from '../../shared/save-path';

/** Approve a Submitted supply request. */
export async function approveSupplyRequest(requestId: string): Promise<void> {
  const { error } = await supabase.rpc('approve_supply_request', { p_request_id: requestId });
  if (error) throw error;
  refreshReaders(['supply_requests']);
}

/** Reject a Submitted supply request, with the reason (required). */
export async function rejectSupplyRequest(requestId: string, reason: string): Promise<void> {
  const why = reason.trim();
  if (!why) throw new Error('A reason is required to reject a supply request.');
  const { error } = await supabase.rpc('reject_supply_request', { p_request_id: requestId, p_reason: why });
  if (error) throw error;
  refreshReaders(['supply_requests']);
}
